(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@angular/forms'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@material/slider')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web/slider', ['exports', '@angular/core', '@angular/common', '@angular/forms', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@material/slider'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.mdcTestWeb = global.shraddhar.mdcTestWeb || {}, global.shraddhar.mdcTestWeb.slider = {}), global.ng.core, global.ng.common, global.ng.forms, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.mdc.slider));
}(this, (function (exports, core, common, forms, coercion, platform, rxjs, operators, slider) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDCComponent = /** @class */ (function () {
        function MDCComponent(elementRef, foundation) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this._elementRef = elementRef;
            this.initialize.apply(this, __spread(args));
            // Note that we initialize foundation here and not within the constructor's default param.
            this._foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
        }
        /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
        MDCComponent.prototype.initialize = function () {
            var _args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                _args[_i] = arguments[_i];
            }
            // Subclasses can override this to do any additional setup work that would be considered part of a
            // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
            // initialized. Any additional arguments besides root and foundation will be passed in here.
        };
        MDCComponent.prototype.getDefaultFoundation = function () {
            // Subclasses must override this method to return a properly configured foundation class for the
            // component.
            throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' +
                'foundation class');
        };
        MDCComponent.prototype.destroy = function () {
            var _a;
            // Subclasses may implement this method to release any resources / deregister any listeners they have
            // attached. An example of this might be deregistering a resize event from the window object.
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        return MDCComponent;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MDC_SLIDER_CONTROL_VALUE_ACCESSOR = {
        provide: forms.NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MdcSlider; }),
        multi: true
    };
    var MdcSliderChange = /** @class */ (function () {
        function MdcSliderChange(source, value) {
            this.source = source;
            this.value = value;
        }
        return MdcSliderChange;
    }());
    var MdcSlider = /** @class */ (function (_super) {
        __extends(MdcSlider, _super);
        function MdcSlider(_platform, _ngZone, _changeDetectorRef, elementRef, tabIndex) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._initialized = false;
            _this.tabIndex = 0;
            _this._discrete = false;
            _this._markers = false;
            _this._min = 0;
            _this._max = 100;
            _this._step = 1;
            _this._value = null;
            _this._disabled = false;
            _this.change = new core.EventEmitter();
            _this.input = new core.EventEmitter();
            /**
             * Emits when the raw value of the slider changes. This is here primarily
             * to facilitate the two-way binding for the `value` input.
             */
            _this.valueChange = new core.EventEmitter();
            /** Function when touched */
            _this._onTouched = function () { };
            /** Function when changed */
            _this._controlValueAccessorChangeFn = function () { };
            _this.tabIndex = parseInt(tabIndex, 10) || 0;
            _this._root = _this.elementRef.nativeElement;
            return _this;
        }
        Object.defineProperty(MdcSlider.prototype, "discrete", {
            get: function () {
                return this._discrete;
            },
            set: function (value) {
                this._discrete = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSlider.prototype, "markers", {
            get: function () {
                return this._markers;
            },
            set: function (value) {
                this._markers = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSlider.prototype, "min", {
            get: function () {
                return this._min;
            },
            set: function (value) {
                var min = coercion.coerceNumberProperty(value);
                if (min !== this._min) {
                    this._min = min;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSlider.prototype, "max", {
            get: function () {
                return this._max;
            },
            set: function (value) {
                var max = coercion.coerceNumberProperty(value);
                if (max !== this._max) {
                    this._max = max;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSlider.prototype, "step", {
            get: function () {
                return this._step;
            },
            set: function (value) {
                var step = coercion.coerceNumberProperty(value, this._step);
                if (step !== this._step) {
                    this._step = step;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSlider.prototype, "value", {
            get: function () {
                if (this._value === null) {
                    this.value = this.min;
                }
                return this._value;
            },
            set: function (newValue) {
                this._value = coercion.coerceNumberProperty(newValue, null);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSlider.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabledState(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcSlider.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                hasClass: function (className) { return _this._root.classList.contains(className); },
                addClass: function (className) { return _this._root.classList.add(className); },
                removeClass: function (className) { return _this._root.classList.remove(className); },
                getAttribute: function (name) { return _this._root.getAttribute(name); },
                setAttribute: function (name, value) { return _this._root.setAttribute(name, value); },
                removeAttribute: function (name) { return _this._root.removeAttribute(name); },
                computeBoundingRect: function () { return _this._root.getBoundingClientRect(); },
                getTabIndex: function () { return _this._root.tabIndex; },
                registerInteractionHandler: function (evtType, handler) {
                    return _this._root.addEventListener(evtType, handler);
                },
                deregisterInteractionHandler: function (evtType, handler) {
                    return _this._root.removeEventListener(evtType, handler);
                },
                registerThumbContainerInteractionHandler: function (evtType, handler) {
                    _this._ngZone.runOutsideAngular(function () {
                        _this.thumbContainer.nativeElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                    });
                },
                deregisterThumbContainerInteractionHandler: function (evtType, handler) {
                    return _this.thumbContainer.nativeElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                },
                registerBodyInteractionHandler: function (evtType, handler) {
                    return document.body.addEventListener(evtType, handler);
                },
                deregisterBodyInteractionHandler: function (evtType, handler) {
                    return document.body.removeEventListener(evtType, handler);
                },
                registerResizeHandler: function () { },
                deregisterResizeHandler: function () { },
                notifyInput: function () {
                    var newValue = _this._foundation.getValue();
                    if (newValue !== _this.value) {
                        _this.value = newValue;
                        _this.input.emit(_this._createChangeEvent(newValue));
                    }
                },
                notifyChange: function () {
                    _this.value = _this._foundation.getValue();
                    _this._emitChangeEvent(_this.value);
                },
                setThumbContainerStyleProperty: function (propertyName, value) {
                    return _this.thumbContainer.nativeElement.style.setProperty(propertyName, value);
                },
                setTrackStyleProperty: function (propertyName, value) {
                    return _this.track.nativeElement.style.setProperty(propertyName, value);
                },
                setMarkerValue: function (value) {
                    _this._changeDetectorRef.markForCheck();
                    _this.pinValueMarker.nativeElement.innerText = value !== null ? value.toString() : null;
                },
                setTrackMarkers: function (step, max, min) {
                    return _this.trackMarkerContainer.nativeElement.style.setProperty('background', _this._getTrackMarkersBackground(step, min, max));
                },
                isRTL: function () { return _this._platform.isBrowser ?
                    window.getComputedStyle(_this._root).getPropertyValue('direction') === 'rtl' : false; },
            };
            return new slider.MDCSliderFoundation(adapter);
        };
        MdcSlider.prototype.ngOnChanges = function (changes) {
            if (!this._initialized) {
                return;
            }
            if (changes['step']) {
                this._syncStepWithFoundation();
            }
            if (changes['max']) {
                this._syncMaxWithFoundation();
            }
            if (changes['min']) {
                this._syncMinWithFoundation();
            }
            if (changes['value']) {
                this._syncValueWithFoundation();
            }
            if (changes['markers'] || changes['discrete']) {
                this._refreshTrackMarkers();
            }
        };
        MdcSlider.prototype._asyncInitializeFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation.init();
                    return [2 /*return*/];
                });
            });
        };
        MdcSlider.prototype.ngAfterViewInit = function () {
            var _this = this;
            if (this._platform.isBrowser) {
                this._initialized = true;
                this._asyncInitializeFoundation()
                    .then(function () {
                    _this._syncStepWithFoundation();
                    _this._syncMaxWithFoundation();
                    _this._syncMinWithFoundation();
                    _this._syncValueWithFoundation();
                    _this._foundation.setupTrackMarker();
                    _this._loadListeners();
                    _this._changeDetectorRef.markForCheck();
                });
            }
        };
        MdcSlider.prototype.ngOnDestroy = function () {
            this._destroyed.next();
            this._destroyed.complete();
            this.destroy();
        };
        MdcSlider.prototype.writeValue = function (value) {
            this.value = value;
            this._syncValueWithFoundation();
        };
        MdcSlider.prototype.registerOnChange = function (fn) {
            this._controlValueAccessorChangeFn = fn;
        };
        MdcSlider.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        MdcSlider.prototype.setDisabledState = function (disabled) {
            this._disabled = coercion.coerceBooleanProperty(disabled);
            this._foundation.setDisabled(disabled);
            this._changeDetectorRef.markForCheck();
        };
        MdcSlider.prototype.layout = function () {
            this._foundation.layout();
        };
        MdcSlider.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(window, 'resize')
                    .pipe(operators.auditTime(16), operators.takeUntil(_this._destroyed))
                    .subscribe(function () { return _this.layout(); });
            });
        };
        MdcSlider.prototype._syncValueWithFoundation = function () {
            this._foundation.setValue(this.value);
        };
        MdcSlider.prototype._syncStepWithFoundation = function () {
            this._foundation.setStep(this.step);
        };
        MdcSlider.prototype._syncMinWithFoundation = function () {
            this._foundation.setMin(this.min);
        };
        MdcSlider.prototype._syncMaxWithFoundation = function () {
            this._foundation.setMax(this.max);
        };
        MdcSlider.prototype._createChangeEvent = function (newValue) {
            return new MdcSliderChange(this, newValue);
        };
        MdcSlider.prototype._emitChangeEvent = function (newValue) {
            this._controlValueAccessorChangeFn(newValue);
            this.valueChange.emit(newValue);
            this.change.emit(this._createChangeEvent(newValue));
        };
        /** Keep calculation in css for better rounding/subpixel behavior. */
        MdcSlider.prototype._getTrackMarkersBackground = function (step, min, max) {
            var stepStr = step.toLocaleString();
            var maxStr = max.toLocaleString();
            var minStr = min.toLocaleString();
            var markerAmount = "((" + maxStr + " - " + minStr + ") / " + stepStr + ")";
            var markerWidth = "2px";
            var markerBkgdImage = "linear-gradient(to right, currentColor " + markerWidth + ", transparent 0)";
            var markerBkgdLayout = "0 center / calc((100% - " + markerWidth + ") / " + markerAmount + ") 100% repeat-x";
            return markerBkgdImage + " " + markerBkgdLayout;
        };
        /** Method that ensures that track markers are refreshed. */
        MdcSlider.prototype._refreshTrackMarkers = function () {
            this._foundation.hasTrackMarker_ = this.markers;
            this._foundation.setupTrackMarker();
        };
        MdcSlider.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-slider',
                        exportAs: 'mdcSlider',
                        host: {
                            'role': 'slider',
                            'aria-orientation': 'horizontal',
                            '[attr.tabindex]': 'tabIndex || 0',
                            'class': 'mdc-slider',
                            '[class.mdc-slider--discrete]': 'discrete',
                            '[class.mdc-slider--display-markers]': 'markers && discrete',
                            '(blur)': '_onTouched()',
                        },
                        template: "<div class=\"mdc-slider__track-container\">\r\n  <div #track class=\"mdc-slider__track\"></div>\r\n  <div #markercontainer *ngIf=\"markers\" class=\"mdc-slider__track-marker-container\"></div>\r\n</div>\r\n<div #thumbcontainer class=\"mdc-slider__thumb-container\">\r\n  <div *ngIf=\"discrete\" class=\"mdc-slider__pin\">\r\n    <span #pin class=\"mdc-slider__pin-value-marker\"></span>\r\n  </div>\r\n  <svg #sliderThumb\r\n    class=\"mdc-slider__thumb\"\r\n    width=\"21\" height=\"21\"\r\n    focusable=\"false\">\r\n    <circle cx=\"10.5\" cy=\"10.5\" r=\"7.875\"></circle>\r\n  </svg>\r\n  <div class=\"mdc-slider__focus-ring\"></div>\r\n</div>",
                        providers: [MDC_SLIDER_CONTROL_VALUE_ACCESSOR],
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcSlider.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.NgZone },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef },
            { type: String, decorators: [{ type: core.Attribute, args: ['tabindex',] }] }
        ]; };
        MdcSlider.propDecorators = {
            tabIndex: [{ type: core.Input }],
            discrete: [{ type: core.Input }],
            markers: [{ type: core.Input }],
            min: [{ type: core.Input }],
            max: [{ type: core.Input }],
            step: [{ type: core.Input }],
            value: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            change: [{ type: core.Output }],
            input: [{ type: core.Output }],
            valueChange: [{ type: core.Output }],
            thumbContainer: [{ type: core.ViewChild, args: ['thumbcontainer', { static: false },] }],
            _sliderThumb: [{ type: core.ViewChild, args: ['sliderThumb', { static: false },] }],
            track: [{ type: core.ViewChild, args: ['track', { static: false },] }],
            pinValueMarker: [{ type: core.ViewChild, args: ['pin', { static: false },] }],
            trackMarkerContainer: [{ type: core.ViewChild, args: ['markercontainer', { static: false },] }]
        };
        return MdcSlider;
    }(MDCComponent));

    var MdcSliderModule = /** @class */ (function () {
        function MdcSliderModule() {
        }
        MdcSliderModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: [MdcSlider],
                        declarations: [MdcSlider]
                    },] }
        ];
        return MdcSliderModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_SLIDER_CONTROL_VALUE_ACCESSOR = MDC_SLIDER_CONTROL_VALUE_ACCESSOR;
    exports.MdcSlider = MdcSlider;
    exports.MdcSliderChange = MdcSliderChange;
    exports.MdcSliderModule = MdcSliderModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-slider.umd.js.map
